import { ILandingProcessedPlanningFetched } from 'partner360/models/landing/ILandingProcessedPlanningFetched'

interface IGetCategories {
  processedPlannings: ILandingProcessedPlanningFetched[]
  selectedPlanningId: string
}
export const getCategories = ({ selectedPlanningId, processedPlannings }: IGetCategories) => {
  return Array.from(
    new Set(
      processedPlannings
        .filter((el) => el.planningId === selectedPlanningId)
        .map((el) => el.category)
    )
  )
}
